import { useDateFormat } from '@/hooks';
import { addDaysToBaliKey } from '@/lib';
import type { MembershipFreeze } from '@/types';

interface MembershipFrozenNotificationProps {
  firstName: string;
  freeze: MembershipFreeze | null;
}

export default function MembershipFrozenNotification({
  firstName,
  freeze,
}: MembershipFrozenNotificationProps) {
  const { formatDate } = useDateFormat();
  if (!freeze) return null;

  return (
    <div className="bg-red-100 border-2 border-red-400 rounded-lg p-4 flex items-center gap-3">
      <span className="text-4xl flex-shrink-0">❄️</span>
      <div>
        <div className="font-bold text-red-800 text-lg">Membership Frozen</div>
        <div className="text-red-700 text-sm">
          {firstName}'s membership is frozen through {formatDate(freeze.end_date, 'date')} (last frozen day).
          They cannot enter the club today — access resumes on {formatDate(addDaysToBaliKey(freeze.end_date, 1), 'date')}.
        </div>
      </div>
    </div>
  );
}
